module.exports = __webpack_public_path__ + "static/media/Elemento SIMEPS 1.414b72f4.svg";